import { type Options as BlurUpOptions, createBlurUp } from '@mux/blurup';

export async function getVideoBlurPlaceholder({
  muxPlaybackId,
  options,
}: {
  muxPlaybackId: string;
  options?: BlurUpOptions;
}) {
  const { blurDataURL, aspectRatio } = await createBlurUp(
    muxPlaybackId,
    options
  );
  return { blurDataURL, aspectRatio };
  // blurDataURL: data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" ...
  // aspectRatio: e.g. 1.777 (16:9)
}

export async function enrichMuxVideosWithPlaceholders(
  content: any
): Promise<any> {
  if (!content) return content;

  if (Array.isArray(content)) {
    return Promise.all(
      content.map((item) => enrichMuxVideosWithPlaceholders(item))
    );
  }

  if (content._type === 'muxVideo' && content.playbackId) {
    const { blurDataURL, aspectRatio } = await getVideoBlurPlaceholder({
      muxPlaybackId: content.playbackId,
    });
    return { ...content, placeholder: blurDataURL, aspectRatio };
  }

  // Recursively handle nested objects
  if (typeof content === 'object') {
    const enriched: any = {};
    for (const key in content) {
      enriched[key] = await enrichMuxVideosWithPlaceholders(content[key]);
    }
    return enriched;
  }

  return content;
}
